<app-page-header
  class="header"
  [backSwipe]="state() === 'main' ? backSwipeConfig : undefined"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <img
    class="logo"
    height="80"
    width="250"
    src="/images/logo.svg"
    alt="Sunset Grill logo">

  <div class="items" coreActivitySection="MoreSelection">
    <button
      class="item"
      coreUserActivityClickTracking="OpenGiftCards"
      (click)="state.set('gift-cards')"
    >
      <div class="label">
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M58.7 32H5.3M32 5.3v53.4M34.7 32c0 5.9 4.7 10.7 10.6 10.7M29.3 32c0 5.9-4.7 10.7-10.6 10.7"
                stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
          <path
            d="M32 26.8c0-4 2.7-7.5 6.6-8.4 4.2-1.1 8.1 2.8 7 7a8.7 8.7 0 0 1-8.4 6.6H32v-5.2ZM32 26.8c0-4-2.7-7.5-6.6-8.4a5.8 5.8 0 0 0-7 7c1 3.9 4.4 6.6 8.4 6.6H32v-5.2Z"
            stroke="currentColor" stroke-width="3"/>
          <path
            d="M5.3 32c0-12.6 0-18.9 4-22.8C13 5.3 19.3 5.3 32 5.3s18.9 0 22.8 4c3.9 3.8 3.9 10.1 3.9 22.7s0 18.9-4 22.8C51 58.7 44.7 58.7 32 58.7s-18.9 0-22.8-4C5.3 51 5.3 44.7 5.3 32Z"
            stroke="currentColor" stroke-width="3"/>
        </svg>
        gift cards
      </div>
      <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
    </button>

    <button
      class="item"
      coreUserActivityClickTracking="OpenLeaveReview"
      (click)="state.set('review')"
    >
      <div class="label">
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="26.7" stroke="currentColor" stroke-width="3"/>
          <path
            d="M28.2 21.9c1.7-3 2.5-4.6 3.8-4.6 1.3 0 2.1 1.5 3.8 4.6l.4.8c.5.8.8 1.3 1.1 1.5.4.3.9.4 1.8.6l.8.2c3.3.8 5 1.1 5.4 2.4.3 1.3-.8 2.6-3 5.2l-.6.6c-.6.8-1 1.2-1 1.6-.2.5-.2 1 0 2v.9c.3 3.5.5 5.2-.5 6-1 .8-2.6 0-5.6-1.4l-.8-.3c-.9-.4-1.3-.6-1.8-.6s-.9.2-1.8.6l-.8.3c-3 1.4-4.6 2.2-5.6 1.4-1-.8-.8-2.5-.5-6v-1c.2-1 .2-1.4 0-1.9 0-.4-.4-.8-1-1.6l-.6-.6c-2.2-2.6-3.3-4-3-5.2.4-1.3 2-1.6 5.4-2.4l.8-.2c1-.2 1.4-.3 1.8-.6.3-.2.6-.7 1-1.5l.5-.8Z"
            stroke="currentColor" stroke-width="3"/>
        </svg>
        Leave a review
      </div>
      <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
    </button>

    <button
      class="item"
      coreUserActivityClickTracking="OpenFollowUsOnSocial"
      (click)="state.set('follow')"
    >
      <div class="label">
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m54.3 28 1.4.5-1.4-.4Zm-4.6 13.8-1.4-.5 1.4.5ZM22.2 14.3l-.5-1.4.5 1.4ZM36 9.7l.5 1.5-.5-1.5ZM6.3 21.5 5 20.8l1.3.7Zm16 14.5.4-1.4-.5 1.4Zm-16-7.2-1.3.7 1.3-.7Zm36.2 28.9-.8-1.3.8 1.3ZM28 41.7l1.4-.4-1.4.5Zm7.2 16 .8-1.3-.8 1.3Zm8.1-34-1-1 1 1Zm0-3 1-1-1 1Zm-3 0-1-1 1 1ZM25.7 35.2l-1-1 1 1Zm3.2 2.8-1-1 1 1Zm25.4-10-1.5-.4-4.5 13.7 1.4.5 1.4.5 4.6-13.8-1.4-.4Zm-32-13.7.4 1.4 13.7-4.5-.5-1.5-.4-1.4-13.8 4.6.5 1.4Zm0 0-.6-1.4c-4.8 1.6-8.5 2.8-11.1 4C8 17.9 6 19 5 20.8l1.3.7 1.3.8c.4-.7 1.5-1.6 4.1-2.7l11-3.9-.5-1.4Zm0 21.7.4-1.4c-4.9-1.6-8.4-2.8-11-4-2.6-1-3.7-1.9-4-2.6l-1.4.8-1.3.7c1 1.7 3 2.9 5.6 4l11.1 4 .5-1.5Zm-16-14.5L5 20.8a8.7 8.7 0 0 0 0 8.7l1.3-.7 1.3-.8c-1-1.7-1-4 0-5.7l-1.3-.8Zm43.4 20.3-1.4-.5c-1.7 4.9-2.8 8.4-4 11-1 2.6-1.9 3.7-2.6 4l.8 1.4.7 1.3c1.7-1 2.9-3 4-5.6l4-11.1-1.5-.5Zm-21.7 0-1.4.5c1.6 4.8 2.8 8.5 4 11.1 1 2.6 2.2 4.6 3.9 5.6l.7-1.3.8-1.3c-.8-.4-1.6-1.5-2.7-4.1-1-2.6-2.3-6.1-3.9-11l-1.4.5Zm14.5 15.9-.8-1.3c-1.8 1-4 1-5.7 0l-.8 1.3-.7 1.3c2.7 1.6 6 1.6 8.7 0l-.7-1.3ZM54.3 28l1.4.4c2-6 3.5-10.5 4.2-14 .6-3.6.4-6.5-1.7-8.7L57 7l-1 1c1 1.1 1.4 2.7.8 6-.6 3.3-2 7.6-4 13.7l1.4.5ZM35.9 9.7l.5 1.5c6-2 10.4-3.5 13.7-4.1 3.3-.6 4.9-.2 6 .9l1-1.1 1-1c-2-2.2-5-2.4-8.5-1.8-3.6.7-8.2 2.2-14.1 4.2l.4 1.4Zm7.4 14 1 1a3.6 3.6 0 0 0 0-5l-1 1-1 1c.2.3.2.7 0 1l1 1Zm0-3 1-1a3.6 3.6 0 0 0-5 0l1 1 1.1 1c.2-.2.6-.2.9 0l1-1Zm-3 0-1-1-14.7 14.5 1 1 1.1 1 14.7-14.5-1-1ZM29 38l1 1 14.5-14.3-1-1-1.1-1-14.5 14.2 1 1Zm0 0-1-1a5.2 5.2 0 0 0-1.3 5.3l1.4-.5 1.4-.5c-.3-.8 0-1.7.5-2.3l-1-1Zm-3.2-2.8-1-1c-.6.4-1.3.6-2 .4l-.5 1.4-.5 1.4c1.7.6 3.7.2 5-1.1l-1-1Z"
            fill="currentColor"/>
        </svg>
        Follow us on social
      </div>
      <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
    </button>

    <button
      coreUserActivityClickTracking="OpenOurStory"
      (click)="state.set('story')"
      class="item"
    >
      <div class="label">
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M50.7 48h1.5-1.5Zm-37.4-9.1h1.5c0-.6-.3-1.1-.9-1.4l-.6 1.4Zm37.4 0-.6-1.4c-.6.3-1 .8-1 1.4h1.6Zm-8.2-20.2a1.5 1.5 0 1 0 3 0h-3Zm-24 0a1.5 1.5 0 1 0 3 0h-3Zm.2-5.4v-1.5c-8.2 0-14.9 6.7-14.9 14.9h3c0-6.6 5.3-11.9 11.9-11.9v-1.5Zm26.6 0v1.5c6.6 0 11.9 5.3 11.9 11.9h3c0-8.2-6.7-14.9-14.9-14.9v1.5ZM40 58.7v-1.5H24v3h16v-1.5Zm-16 0v-1.5c-2.6 0-4.3 0-5.7-.2-1.2-.2-1.9-.5-2.3-1l-1.1 1.1-1 1a6.8 6.8 0 0 0 4 1.9c1.6.2 3.6.2 6.1.2v-1.5ZM13.3 48h-1.5c0 2.5 0 4.5.2 6 .3 1.7.7 3 1.8 4.2L15 57l1-1c-.4-.5-.7-1.2-.9-2.4-.2-1.4-.2-3.1-.2-5.7h-1.5Zm37.4 0h-1.5c0 2.6 0 4.3-.2 5.7-.2 1.2-.5 1.9-1 2.3l1.1 1.1 1 1a6.8 6.8 0 0 0 1.9-4c.2-1.6.2-3.6.2-6.1h-1.5ZM40 58.7v1.5c2.5 0 4.5 0 6-.2 1.7-.3 3-.7 4.2-1.8L49 57l-1-1c-.5.4-1.2.7-2.4.9-1.4.2-3.1.2-5.7.2v1.5ZM18.7 13.3v1.5c.6 0 1.1 0 1.7.2l.2-1.5.3-1.5a15 15 0 0 0-2.2-.2v1.5Zm13.3-8V3.8c-6 0-11 3.9-12.8 9.2l1.4.5 1.5.5c1.4-4.2 5.3-7.2 9.9-7.2V5.3Zm-11.4 8.2-1.4-.5c-.5 1.4-.7 2.8-.7 4.3h3c0-1.1.2-2.3.6-3.3l-1.5-.5Zm24.7-.2v-1.5c-.7 0-1.4 0-2.2.2l.3 1.5.2 1.5 1.7-.2v-1.5ZM32 5.3v1.5c4.6 0 8.5 3 10 7.2l1.4-.5 1.4-.5A13.5 13.5 0 0 0 32 3.8v1.5Zm11.4 8.2-1.5.5c.4 1 .6 2.2.6 3.3h3c0-1.5-.3-3-.7-4.3l-1.4.5ZM13.4 48h1.4v-9.1h-3V48h1.5Zm0-9.1.5-1.4c-4.1-1.8-7-6-7-10.8H3.7c0 6 3.7 11.3 9 13.6l.5-1.4Zm37.3 0h-1.5V48h3v-9.1h-1.5Zm8-12.2h-1.5c0 4.8-3 9-7.1 10.8l.6 1.4.6 1.4c5.2-2.3 8.9-7.5 8.9-13.6h-1.5ZM44 17.3h-1.5v1.4h3v-1.4H44Zm-24 0h-1.5v1.4h3v-1.4H20ZM29.4 36.5l-.8 1.2.8-1.2Zm2.6-9.8-1 1c.5.6 1.5.6 2 0l-1-1Zm2.6 9.8-1-1.3 1 1.3ZM32 37.7v-1.5 1.5Zm-2.6-1.2 1-1.3c-1.2-.8-2.5-1.8-3.4-3-1-1.1-1.5-2.1-1.5-2.9h-3c0 1.9 1 3.6 2.2 5 1.2 1.3 2.6 2.5 3.9 3.4l.8-1.2ZM24 29.3h1.5c0-1.7.8-2.6 1.6-2.9 1-.3 2.4-.1 3.9 1.3l1-1 1-1.1c-2-2-4.6-2.8-6.8-2-2.3.8-3.7 3-3.7 5.7H24Zm10.6 7.2.8 1.2c1.3-1 2.7-2.1 3.9-3.5 1.1-1.3 2.2-3 2.2-4.9h-3c0 .8-.5 1.8-1.5 3l-3.3 3 .9 1.2Zm5.4-7.2h1.5c0-2.7-1.4-4.9-3.7-5.7-2.2-.8-4.7 0-6.8 2l1 1 1 1.1c1.5-1.4 3-1.6 3.9-1.3.8.3 1.6 1.2 1.6 3H40Zm-10.6 7.2-.8 1.2c1 .7 2 1.5 3.4 1.5v-3c-.3 0-.4 0-1.7-1l-.9 1.3Zm5.2 0-1-1.3c-1.2 1-1.3 1-1.6 1v3c1.5 0 2.4-.8 3.4-1.5l-.8-1.2Z"
            fill="currentColor"/>
          <path d="M13.3 48h37.4" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
        Our Story
      </div>
      <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
    </button>

    <button
      coreUserActivityClickTracking="OpenCatering"
      (click)="state.set('catering')"
      class="item"
    >
      <div class="label">
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.3 15.2a9.8 9.8 0 0 1 19.7 0v26.6a16.8 16.8 0 0 0 33.7 0v-3.1" stroke="#fff" stroke-width="3" stroke-linecap="round"/>
          <path d="M58.7 38.7c0 3.6-7.9 6.6-16 6.6-8.2 0-17.4-3-17.4-6.6 0-3.7 9.2-6.7 17.4-6.7 8.1 0 16 3 16 6.7Z" stroke="#fff" stroke-width="3"/>
        </svg>
        Catering
      </div>
      <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
    </button>

  </div>
</div>

@switch (state()) {
  @case ('gift-cards') {
    <app-more-gift-cards
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('review') {
    <app-more-review
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('follow') {
    <app-more-follow
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('story') {
    <app-more-story
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('catering') {
    <app-more-catering
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
}
